import React from 'react'
import PropTypes from 'prop-types'
import styled, { keyframes, css } from 'styled-components'
import type { Pokemon } from './types'

const shakeAnimation = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(5deg); }
  50% { transform: rotate(0eg); }
  75% { transform: rotate(-5deg); }
  100% { transform: rotate(0deg); }
`

const StlyedTile = styled.div<{ isSelected: boolean, shake: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  background-color: ${props => (props.isSelected) ? 'lightblue' : 'white'};
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
  animation: ${props => props.shake ? css`${shakeAnimation} .1s linear 0s 3` : 'none'};
  height: 8rem;
  width: 8rem;

  @media (max-width: 768px) {
    height: 6rem;
    width: 6rem;
  }

  @media (max-width: 480px) {
    height: 4rem;
    width: 4rem;
  }

  &:not(:disabled):hover {
    transform: scale(1.05);
   }
 
   &:not(:disabled):hover:active {
     transform: scale(1.05) translateY(.125rem);
   }
`

const StyledName = styled.h4`
  text-transform: capitalize;
  font-weight: bold;
  margin: 0;
  font-size: .75rem;
  padding-top: .5rem;

  @media (max-width: 768px) {
    font-size: .5rem;
  }

  @media (max-width: 480px) {
    display: none;
  }
`

const StyledImage = styled.img`
  width: 5rem;
  height: 5rem;

  @media (max-width: 768px) {
    width: 3rem;
    height: 3rem;
  }

  @media (max-width: 480px) {
    width: 2rem;
    height: 2rem;
  }

  @media (max-width: 320px) {
    width: 1rem;
    height: 1rem;
  }
`

interface TileProps {
  pokemon: Pokemon
  isSelected: boolean
  shake: boolean
  handleClick: (pokemon: Pokemon) => void
}

function Tile ({ pokemon, isSelected, shake, handleClick }: TileProps): JSX.Element {
  const trimmedName = pokemon.name.replace('-', ' ')
  return (
    <StlyedTile isSelected={isSelected} shake={shake} onClick={() => { handleClick(pokemon) }}>
        <StyledImage src={pokemon.sprites.front_default} alt={pokemon.name} />
        <StyledName>{trimmedName}</StyledName>
    </StlyedTile>
  )
}

Tile.propTypes = {
  pokemon: PropTypes.object.isRequired,
  shake: PropTypes.bool,
  isSelected: PropTypes.bool,
  handleClick: PropTypes.func
}

export default Tile
